export class FlowchartStep {
	type = 'FlowchartStep';
	id: string;
	chapterId?: string;
	isStart?: boolean;
	title?: string;
	entityType?: string;
	entityId?: string;
	description?: string;
	x: number;
	y: number;
	col: number;
	row: number;
	width: number;
	height: number;
	stepsIn: any;
	stepsOut: any;

	constructor( props: any ) {
		this.id = this._generateId();
		if (typeof props.isStart === 'undefined') {
			this.isStart = false;
		}
		if ( ! props.entityType) {
			props.entityType = 'mediaclip';
		}
		this.update( props );
	}

	update( props: any ) {
		Object.keys(props).forEach( prop => this[prop] = props[prop] );
	}

	private _generateId() {
		return 'id-' + Math.random().toString(36).substr(2, 16);
	}
}
